export class DevOpsAction {
    eventRuleId?: string;
    region?: string;
    customerId?: string;
    accountId?: string;
    environmentId?: string;
    actionName?: string;
    scheduleExpression?: string;
    triggerTime?: Date;
    scheduleDescription?: string;
    nextTriggers?: Date[];
    lastRunIds?: string[];
    definingUser?: string;
}